
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifts",
      function () {
        return require("private-next-pages/gifts.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifts"])
      });
    }
  